import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { AuthState, AuthResponse } from './types';

export const ACCESS_TOKEN_KEY = 'accessToken';
const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);

const initialState: AuthState = {
  user: null,
  accessToken,
  isAuthenticated: !!accessToken,
  isLoading: false,
  error: null
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthResponse: (state, action: PayloadAction<AuthResponse>) => {
      const response = action.payload;

      state.user = {
        id: String(response.userId),
        email: response.userEmail,
        name: response.userName,
        role: 'user',
        provider: state.user?.provider || 'azure'
      };

      state.accessToken = response.token;
      state.isAuthenticated = true;
      state.error = null;

      localStorage.setItem(ACCESS_TOKEN_KEY, response.token);
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
      localStorage.removeItem(ACCESS_TOKEN_KEY);
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const { setAuthResponse, logout, setLoading, setError, clearError } = authSlice.actions;
